var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrcafinaLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2966 3.74355L26.1715 8.86746C26.7882 9.22351 27.169 9.88061 27.1714 10.5927L27.206 20.7507C27.2084 21.468 26.8265 22.1317 26.2051 22.49L17.3546 27.594C16.736 27.9508 15.974 27.9506 15.3555 27.5935L6.42999 22.4403C5.81149 22.0833 5.43034 21.4235 5.42998 20.7093L5.42491 10.4993C5.42455 9.77839 5.81221 9.11306 6.43956 8.75788L15.3112 3.73517C15.9278 3.38611 16.683 3.3893 17.2966 3.74355Z",
    stroke: "black",
    strokeWidth: 3.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0815 9.56582C21.6385 9.00077 10.7523 11.2836 10.7523 24.9352",
    stroke: "black",
    strokeWidth: 3.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0815 21.3273C21.6385 21.8924 10.7523 19.6096 10.7523 5.95797",
    stroke: "black",
    strokeWidth: 3.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrcafinaLogo2);
export default __webpack_public_path__ + "static/media/OrcafinaLogo2.5c30ce507d294b92c3922115a0ef9d08.svg";
export { ForwardRef as ReactComponent };